/**
 * Use branding API URL as-is. Partner-ms already appends ?v=<mtime> when the
 * file changes; Date.now() here forced a full logo re-download on every visit.
 */
export function withConsentLogoCacheBust(url) {
  return url || '';
}
